import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../services/api';
import Loader from '../components/Loader';

interface Barter {
  id: string;
  offerTitle: string;
  offerDescription: string;
  offerImages: string[];
  wantTitle: string;
  wantDescription: string;
  createdAt: string;
  user: {
    firstName: string;
    rating: number;
  };
}

export default function Barters() {
  const [barters, setBarters] = useState<Barter[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadBarters();
  }, []);

  const loadBarters = async () => {
    setIsLoading(true);
    try {
      const response = await apiService.getBarters({});
      setBarters(response.data.data || []);
    } catch (error) {
      console.error('Error loading barters:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">🔁 Бартер</h1>
        <Link to="/barters/create" className="btn-primary text-sm">
          ➕ Создать
        </Link>
      </div>

      <p className="text-sm text-tg-theme-hint">
        Обменивайтесь товарами без денег!
      </p>

      {isLoading ? (
        <Loader className="py-8" />
      ) : barters.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-4xl mb-2">🔄</p>
          <p className="text-tg-theme-hint">Предложений обмена пока нет</p>
          <Link to="/barters/create" className="btn-primary mt-4 inline-block">
            Создать первое
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {barters.map((barter) => (
            <Link key={barter.id} to={`/barters/${barter.id}`}>
              <div className="card hover:opacity-90">
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
                    Отдам
                  </span>
                  <h3 className="font-semibold flex-1 truncate">{barter.offerTitle}</h3>
                </div>
                
                <div className="text-2xl text-center my-2">🔄</div>
                
                <div className="flex items-center gap-2 mb-3">
                  <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">
                    Получу
                  </span>
                  <h3 className="font-semibold flex-1 truncate">{barter.wantTitle}</h3>
                </div>

                <div className="flex items-center justify-between text-xs text-tg-theme-hint">
                  <span>⭐️ {barter.user.rating.toFixed(1)} • {barter.user.firstName}</span>
                  <span>{new Date(barter.createdAt).toLocaleDateString('ru-RU')}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
